export const FindItemAudio = {
  bgm: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameBgm.mp3`),
  start: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameStart.mp3`),
  correct: new Audio(
    `${process.env.PUBLIC_URL}/knockknock/audio/gameCorrect.mp3`
  ),
  wrong: new Audio(`${process.env.PUBLIC_URL}/knockknock/audio/gameWrong.mp3`),
};

export const arraivalAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/knockknock3.mp3`
);
export const cancelAudio = new Audio(
  `${process.env.PUBLIC_URL}/knockknock/audio/bell.mp3`
);
